import axios from 'axios';
import store from './store/store';
import {GET_USER_DETAILS} from './store/storeconstants'
const axiosInstance =axios.create({});

axiosInstance.interceptors.request.use((config)=>{
    const userdata = store.getters[`auth/${GET_USER_DETAILS}`];
        config.headers['Authorization'] = `Bearer ${userdata.data.token}`;
    return config; 
});

export default axiosInstance;